import React, { Component } from "react";
import styles from "../PricingWrapper.module.scss";
import Button from "@material-ui/core/Button";
import { withTranslation } from "react-i18next";
import { ValidatorForm } from "react-material-ui-form-validator";
import AppliedPricing from "../../../../shared/appliedPricing/AppliedPricing";
import vehiclesStyles from "../nscVehicles/NscVehicles.module.scss";
import ValidationRules from "../../../../common/ValidationRules";
import DealerFeesHeader from "./dealerFeesHeader/DealerFeesHeader";
import DealerFeesRow from "./dealerFeesRow/DealerFeesRow";
import SortData from "../../../../utils/SortUtil";
import HasPermissionTo from "../../../../common/HasPermissionTo";
import { FEES_MAP, GPRS_ERROR_MESSAGE } from "../../../../common/Constants";
import UpperCaseText from "../../../../utils/UpperCaseText";

class DealerFees extends Component {
  constructor(props) {
    super(props);
    this.state = {
      feesData: this.props.feesData,
      editEnabled: {
        numberPlates: false,
        additionalFees: false,
        deliveryFee: false,
        firstRegFee: false,
        cityFee: false,
        handlingFee: false,
        malusFee: false,
        baseRegistrationTax: false,
      },
      editFlags: {
        numberPlates: true,
        additionalFees: true,
        deliveryFee: true,
        firstRegFee: true,
        cityFee: true,
        handlingFee: true,
        malusFee: true,
        baseRegistrationTax: true,
      },
      sortDirection: null,
      sortKey: "dealerFeesInfo",
    };

    this.updateDealerFees = this.updateDealerFees.bind(this);
  }

  componentDidMount() {
    ValidationRules();
    this.makeCopyOfFeesData();
    Array.isArray(this.props.catalogIds) &&
      this.props.catalogIds.length > 1 &&
      this.sortDealerFeesData("year");
  }

  handleEdit = (e, index, key) => {
    const feesData = JSON.parse(JSON.stringify(this.state.feesData));
    feesData[index][key] = e.target.value;
    this.setState({ feesData });
  };

  makeCopyOfFeesData() {
    this.feesDataCopy = JSON.parse(JSON.stringify(this.state.feesData));
  }

  navigateToOptions = (e) => {
    this.props.handleTabChange(e, 1);
  };

  updateEditFlags = (column) => {
    const editFlags = this.state.editFlags;
    const editEnabled = this.state.editEnabled;

    for (const property in editFlags) {
      if (property !== column) {
        editFlags[property] = !this.state.editFlags[property];
      }
    }
    editEnabled[column] = !this.state.editEnabled[column];

    this.setState({ editEnabled, editFlags });
  };

  cancelUpdate = (column) => {
    this.setState({ feesData: this.feesDataCopy });
    this.updateEditFlags(column);
  };

  updateDealerFees() {
    const editFlags = this.state.editFlags;
    const editEnabled = this.state.editEnabled;
    Object.keys(editFlags).forEach((flag) => (editFlags[flag] = true));
    Object.keys(editEnabled).forEach((flag) => (editEnabled[flag] = false));
    this.feesDataCopy = this.state.feesData;
    this.props.updateFeesData(this.state.feesData);
    this.setState({
      editEnabled,
      editFlags,
    });
  }

  sortDealerFeesData(sortByCol) {
    let sortDir = "DSC";
    if (sortByCol === this.state.sortKey) {
      sortDir = this.state.sortDirection === "ASC" ? "DSC" : "ASC";
    }

    const that = this;
    SortData(
      sortByCol,
      sortDir,
      "alphanumeric",
      this.state.feesData,
      function (sortedData) {
        that.setState({
          feesData: sortedData,
          sortDirection: sortDir,
          sortKey: sortByCol,
        });
      }
    );
  }

  render() {
    return this.props.feesData && this.props.feesData.length > 0 ? (
      <div>
        <ValidatorForm onSubmit={this.updateDealerFees}>
          <DealerFeesHeader
            {...this.props}
            fees={FEES_MAP[UpperCaseText(this.props.selectedMarket)]}
            updateEditFlags={this.updateEditFlags}
            cancelUpdate={this.cancelUpdate}
            editFlags={this.state.editFlags}
            editEnabled={this.state.editEnabled}
            isDisabled={true}
            sortKey={this.state.sortKey}
            sortDirection={this.state.sortDirection}
            onClick={(key) => this.sortDealerFeesData(key)}
          />
          {this.state.feesData.map((item, index) => (
            <DealerFeesRow
              {...this.props}
              fees={FEES_MAP[UpperCaseText(this.props.selectedMarket)]}
              item={item}
              index={index}
              handleEdit={this.handleEdit}
              editEnabled={this.state.editEnabled}
              isDisabled={true}
              key={index}
              released={this.props.released}
              editChecked={this.props.editChecked}
              rowEditSaved={this.props.rowEditSaved}
              rowEditedCheckbox={this.props.rowEditedCheckbox}
              newlyReleased={this.props.newlyReleased}
            />
          ))}
          {this.props.released &&
          !this.props.priceUpdatesAvailable &&
          !this.props.buttonEnabled &&
          !this.props.pendingActionExist &&
          !this.props.editEnabled &&
          !this.props.viewOnlyPricing ? (
            <div>
              {this.props.rowEditSaved ? (
                <div className={styles.appliedPricing}>
                  <AppliedPricing />
                </div>
              ) : (
                ""
              )}
            </div>
          ) : (
            <div className={vehiclesStyles.actionSection}>
              <HasPermissionTo
                permissions={this.props.user.permissions.rolePermissions}
                perform={["vehiclePricing:view"]}
                render={() => (
                  <Button
                    data-testid="applyFeesBtn"
                    disabled={
                      this.state.editEnabled.numberPlates ||
                      this.state.editEnabled.additionalFees ||
                      this.state.editEnabled.deliveryFee ||
                      this.state.editEnabled.firstRegFee ||
                      this.state.editEnabled.cityFee ||
                      this.state.editEnabled.handlingFee ||
                      this.props.user.readOnly
                    }
                    variant="contained"
                    onClick={(event) => {
                      this.navigateToOptions(event);
                    }}
                    className={vehiclesStyles.applyBtn}
                    component="button"
                  >
                    <span>{this.props.t("DealerVehicles.next")}</span>
                  </Button>
                )}
              />
            </div>
          )}
        </ValidatorForm>
      </div>
    ) : this.props.errorMessage === GPRS_ERROR_MESSAGE ? (
      <span className={styles.dataNotFound}>
        {" "}
        {this.props.t("Error.dataNotFoundFromSource")}
      </span>
    ) : (
      <span className={styles.dataNotFound}>
        {" "}
        {this.props.t("Error.dataNotFound")}
      </span>
    );
  }
}

export default withTranslation("emp")(DealerFees);
